import { Button, Select } from "antd";
import Input from "antd/lib/input/Input";
import { useHistory } from "react-router-dom";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { Locale } from "../../../utils";
import { getList } from "../../../utils/http/dataProvider";
import { getUserInfo } from "../../../utils/redux/reducers/User";

const i18n = Locale.getInstance();
const { Option } = Select;

const AlbumListHeader = ({
  keyword,
  setKeyword,
  categoryId,
  setCategoryId,
  status,
  setStatus,
  notForSaleFilter,
  setNotForSaleFilter,
}) => {
  const router = useHistory();
  const user = useSelector((state) => getUserInfo(state));

  const { data: categoriesData } = useQuery(
    ["course-categories", user.token],
    () =>
      getList("course/categories", {
        pagination: {
          perPage: 1000,
          page: 1,
        },
        sort: {
          field: "id",
          order: "desc",
        },
        token: user.token,
      })
  );

  const flattenCategories = (categories, result = []) => {
    if (!categories) return result;
    categories.forEach((cat) => {
      result.push(cat);
      if (cat.sub_categories && cat.sub_categories.length > 0) {
        flattenCategories(cat.sub_categories, result);
      }
    });
    return result;
  };

  const categories = categoriesData?.data ? flattenCategories(categoriesData.data) : [];

  return (
    <div className="header">
      <div className="actions">
        <Button
          onClick={() => {
            router.push({
              pathname: `/main/courses/albums/edit`,
            });
          }}
          type="primary"
        >
          {i18n.t("course.album.add")}
        </Button>
      </div>
      <div className="search">
        <Select
          style={{ width: 150, marginRight: 8 }}
          placeholder={i18n.t("common.statusLabel")}
          allowClear
          value={status === undefined ? undefined : status}
          onChange={(value) => setStatus(value)}
        >
          <Option value={1}>{i18n.t("course.album.statusOnShelf")}</Option>
          <Option value={0}>{i18n.t("course.album.statusOffShelf")}</Option>
        </Select>
        <Select
          style={{ width: 200, marginRight: 8 }}
          placeholder={i18n.t("course.selectCategory")}
          allowClear
          value={categoryId === 0 ? undefined : categoryId}
          onChange={(value) => setCategoryId(value || 0)}
        >
          {categories.map((cat) => (
            <Option key={cat.id} value={cat.id}>
              {i18n.getPropNameByLocale(cat, "name")}
            </Option>
          ))}
        </Select>
        <Select
          style={{ width: 160, marginRight: 8 }}
          placeholder={i18n.t("course.saleTypeFilter")}
          allowClear
          value={notForSaleFilter}
          onChange={(value) => setNotForSaleFilter(value)}
        >
          <Option value={0}>{i18n.t("course.forSale")}</Option>
          <Option value={1}>{i18n.t("course.notForSale")}</Option>
        </Select>
        <Input
          defaultValue={keyword}
          onChange={(e) => {
            setKeyword(e.target.value);
          }}
          placeholder={i18n.t("course.album.name")}
          style={{ width: 200, marginRight: 8 }}
        />
        <Button type="primary">{i18n.t("common.search")}</Button>
      </div>
    </div>
  );
};
export default AlbumListHeader;


